import { getShouldDisplaySeeding } from 'helpers';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ConditionsRoutes } from 'views/Results/Conditions/Conditions';
import { InsightsRoutes } from 'views/Results/Insights';
import AllMetricsRedesign from 'views/Results/Insights/AllMetrics';
import { MicrobiomeRoutes } from 'views/Results/Microbiome/Microbiome';
import { SeedingRoutes } from 'views/Results/Seeding';

import useFeature from 'services/features/useFeature';
import Summary from './Summary/Summary';

export const ResultsReadyRoutes = () => {
  const { currentKit, currentKitId } = useCurrentKitAndTinyAccount();
  const { isFeatureEnabled: isAllMetricsRedesignEnabled } = useFeature(
    'all_metrics_page_redesign',
  );

  if (!currentKitId) {
    return <Navigate to='/results' replace />;
  }
  return (
    <Routes>
      <Route path='insights/*' element={<InsightsRoutes />} />
      {isAllMetricsRedesignEnabled && (
        <Route path='metrics/all-metrics' element={<AllMetricsRedesign />} />
      )}
      <Route path='microbiome' element={<MicrobiomeRoutes />} />
      <Route path='conditions/*' element={<ConditionsRoutes />} />

      {currentKit && getShouldDisplaySeeding(currentKit) ? (
        <Route path='seeding' element={<SeedingRoutes />} />
      ) : null}
      <Route path={`/*`} element={<Summary />} />
    </Routes>
  );
};
